$(window).on("load", function() {
	$("body").on("mousedown", () => $("body").addClass('using-mouse'));
	$("body").on("keydown", () => $("body").removeClass('using-mouse'));
});
